import {createAction} from '@reduxjs/toolkit';

import {createGeometryObj} from '@explorer/util/geom';
import {geocode} from '../util/search.js';

const actionPrefix = 'SEARCH';

export const setDateRanges = createAction(`${actionPrefix}/SET_DATE_RANGES`);

export const resetDateRanges = createAction(
  `${actionPrefix}/RESET_DATE_RANGES`
);

export const saveGeometry = createAction(`${actionPrefix}/SAVE_GEOMETRY`);

export const setIsGeometryTooComplex = createAction(
  `${actionPrefix}/IS_GEOMETRY_TOO_COMPLEX`
);

export const defineGeometry =
  ({geometry, zoomTo = true, isGeometryTooComplex = false, fromHash = false}) =>
  dispatch => {
    const {newGeometry, geometryTooLarge, center} = createGeometryObj(geometry);

    let name = '';

    geocode(center).then(response => {
      if (response.features) {
        name = response.features[0]?.place_name || '';
      }

      dispatch(
        saveGeometry({
          geometry: newGeometry,
          geometryTooLarge,
          name,
          geometryZoomTo: zoomTo,
          isGeometryTooComplex,
          fromHash,
        })
      );
    });
  };

export const continueSearch = createAction(`${actionPrefix}/CONTINUE_SEARCH`);

export const clearSearch = createAction(`${actionPrefix}/CLEAR_SEARCH`);

export const toggleNoEndDate = createAction(
  `${actionPrefix}/TOGGLE_NO_END_DATE`
);

export const loadSearch = createAction(`${actionPrefix}/LOAD_SEARCH`);

export const searchSingleItem = createAction(
  `${actionPrefix}/SEARCH_SINGLE_ITEM`
);

export const executeSearch = createAction(`${actionPrefix}/EXECUTE_SEARCH`);

export const resetSearchPageNumber = createAction(
  `${actionPrefix}/RESET_SEARCH_PAGE_NUMBER`
);
